import BigNumber from 'bignumber.js'
import { useMemo } from 'react'
import { useAccount } from 'wagmi'

import type {
  DelegatorTotalIncentiveType,
  StoremanDelegatorInfoType,
} from '@/types/storeman-type'
import { useIwan } from '@/utils/useWebSocket'

export const useStoremanGroupInfo = (groupId: string | undefined) => {
  const { data } = useIwan(['getStoremanGroupInfo'], { groupId }, !!groupId)
  return useMemo(() => {
    if (data) {
      return data
    } else {
      return null
    }
  }, [data])
}

export const useStoremanDelegatorInfo = () => {
  const { address } = useAccount()
  const { data } = useIwan(['getStoremanDelegatorInfo'], { address }, !!address)
  return useMemo(() => {
    const ret: any[] = []
    if (data) {
      data.forEach((v: StoremanDelegatorInfoType) => {
        ret.push({
          ...v,
          deposit: new BigNumber(v.deposit)
            .dividedBy(Math.pow(10, 18).toString(10))
            .toString(10),
          incentive: new BigNumber(v.incentive)
            .dividedBy(Math.pow(10, 18).toString(10))
            .toString(10),
        })
      })
      return ret
    } else {
      return []
    }
  }, [data])
}

export const useDelegatorTotalIncentive = () => {
  const { address } = useAccount()
  const { data } = useIwan(
    ['getDelegatorTotalIncentive'],
    { chainType: 'WAN', address },
    !!address,
  )
  return useMemo(() => {
    if (data) {
      data.forEach(
        (v: DelegatorTotalIncentiveType) =>
          (v.amount = new BigNumber(v.amount).dividedBy(
            Math.pow(10, 18).toString(10),
          )),
      )
      return data
    } else {
      return []
    }
  }, [data])
}
